export default __webpack_public_path__ + "static/media/logo_facebook.f4b72506.svg";